import * as Utils from "../utils/Config";
import { ApiClient } from "./ApiClient";
import { ISaveGeneralDentalReferral, IGeneralDentalReferralAttachmentCategory } from "../models/IGeneralDentalReferral";

export class GeneralDentalReferralAdministrationApi extends ApiClient {

    saveGeneralDentalReferral(data: ISaveGeneralDentalReferral, success: (generalDentalReferralId: number) => void, error?: (message: string) => void, final?: () => void) {
        this.postWithResponse(`${Utils.LIB_API_BASE_URL}/generalDentalReferralAdministration/save`, data, success, error, final);
    }

    sendGeneralDentalReferral(data: ISaveGeneralDentalReferral, success: (generalDentalReferralId: number) => void, error?: (message: string) => void, final?: () => void) {
        this.postWithResponse(`${Utils.LIB_API_BASE_URL}/generalDentalReferralAdministration/send`, data, success, error, final);
    }

    getGeneralDentalReferralAttachmentCategories(success: (data: IGeneralDentalReferralAttachmentCategory[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<IGeneralDentalReferralAttachmentCategory[]>(`${Utils.LIB_API_BASE_URL}/generalDentalReferralAdministration/attachmentCategories`, success, error, final);
    }

    removeGeneralDentalReferralAttachment(attachmentId: string, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.delete(`${Utils.LIB_API_BASE_URL}/generalDentalReferralAdministration/removeAttachment/${attachmentId}`, success, error, final);
    }

    deleteGeneralDentalReferral(generalDentalReferralId: string, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.delete(`${Utils.LIB_API_BASE_URL}/generalDentalReferralAdministration/deleteGeneralDentalReferral/${generalDentalReferralId}`, success, error, final);
    }

    markReferralAnswerAsRead(generalDentalReferralId: number, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/generalDentalReferralAdministration/markAnswerAsRead/${generalDentalReferralId}`, undefined, success, error, final);
    }

    withdrawGeneralDentalReferral(generalDentalReferralId: number, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/generalDentalReferralAdministration/withdraw/${generalDentalReferralId}`, undefined, success, error, final);
    }
}